const validateModule = (module) => {
  let message = "";
  if (!module.title.trim()) {
    message += "Module title cannot be empty.\n";
  }

  if (!module.icon.src.trim() || !module.icon.name.trim()) {
    message += "Lesson icon cannot be empty.\n";
  }

  if (module.categories.length < 1) {
    message += "A module must be assigned at least one category.\n";
  }

  if (module.lessons.length < 1) {
    message += "A module must have at least one lesson.\n";
  }

  if (message) {
    alert(message);
    return false;
  }
  return true;
};

export default validateModule;
